// src/services/entriesService.ts

import { getAuthToken } from "./authService";
import { BASE_URL } from "../utils/config";
import { messageToast } from "../components/common/toastMessage";
import { EntryDetails, UserEntry } from "../types/api";

export async function getEntries(): Promise<UserEntry[]> {
	try {
		const response = await fetch(`${BASE_URL}/entries`, {
			method: "GET",
			headers: {
				Authorization: `Bearer ${getAuthToken()}`,
				"Content-Type": "application/json",
			},
		});

		if (response.ok) {
			return await response.json();
		}
		return [];
	} catch (error) {
		console.error("Failed to fetch entries:", error);
		return [];
	}
}

export async function getEntry(entryId: string): Promise<EntryDetails | null> {
	try {
		const response = await fetch(`${BASE_URL}/entries/${entryId}`, {
			method: "GET",
			headers: {
				Authorization: `Bearer ${getAuthToken()}`,
				"Content-Type": "application/json",
			},
		});
		if (response.ok) {
			return await response.json();
		}
		return null;
	} catch (error) {
		console.error("Error fetching entry:", error);
		return null;
	}
}


export async function getSharedEntry(shareSlug: string): Promise<EntryDetails | null> {
	try {
		const response = await fetch(`${BASE_URL}/entries/shared/${shareSlug}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			// No Authorization header needed for public shared entries
		});
		if (response.ok) {
			return await response.json();
		}
		return null;
	} catch (error) {
		console.error("Error fetching shared entry:", error);
		return null;
	}
}

export async function generateVideo(entryId: string): Promise<boolean> {
	try {
		const response = await fetch(
			`${BASE_URL}/entries/${entryId}/generate-highlight`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${getAuthToken()}`,
				},
			}
		);
		return response.ok;
	} catch (error) {
		console.error("Error generating video:", error);
		return false;
	}
}

export async function submitHoleInOne(data: any): Promise<void> {
	const formData = new FormData();
	for (const key in data) {
		formData.append(key, data[key]);
	}

	try {
		const response = await fetch(`${BASE_URL}/entries/hole_in_one`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${getAuthToken()}`,
			},
			body: formData,
		});

		if (response.ok) {
			messageToast({
				message: "Your hole in one has been submitted for verification.",
			});
			window.location.reload();
		} else {
			const errorData = await response.json();
			messageToast({ message: errorData.message, background: "text-bg-danger" });
		}
	} catch (error) {
		console.error("Error submitting hole in one:", error);
		messageToast({
			message: "An unexpected error occurred.",
			background: "text-bg-danger",
		});
	}
}
